module.exports = __webpack_public_path__ + "static/media/Map D.6bbe91dc.png";